<template>
  <b-card>
    <!-- table -->
    <vue-good-table
      ref="my-table-user"
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :selectedRows="selectedRows"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- <span class="text-nowrap">
          <span class="text-nowrap">{{
            props.formattedRow[props.column.field]
          }}</span>
        </span> -->
        <!-- Column: Name -->
        <span v-if="props.column.field === 'fullName'" class="text-nowrap">
          <span class="text-nowrap">{{
            props.row.committeeData != null
              ? props.row.committeeData.firstname +
                " " +
                props.row.committeeData.lastname
              : ""
          }}</span>
        </span>


        <!-- Column: Name -->
        <span v-if="props.column.field === 'position'" class="text-nowrap">
          <span class="text-nowrap">{{
            props.row.committeeData != null
              ? props.row.committeeData.position
              : ""
          }}</span>
        </span>

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'directorPositionName'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{
            props.row.committeeData != null
              ? props.row.committeeData.directorPositionName
              : ""
          }}</span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BFormCheckboxGroup,
  BFormCheckbox, // ,BRow, BCol, BFormTextarea, BFormRadio, BTab, BTabs,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { codeBasic } from "@/views/table/vue-good-table/code";
import store from "@/store/index";
import * as subcommitteeStore from "@/store/api/subcommittee/index.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {},
  setup(props) {
    // return {
    //   rows: props.users,
    // };
  },
  data() {
    return {
      rows: [],
      selectedRows: [],
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: [
        {
          label: "ชื่อ - นามสกุล",
          field: "fullName",
        },
        {
          label: "ตำแหน่งงาน",
          field: "position",
        },
        {
          label: "ตำแหน่งในอนุกรรมการ",
          field: "directorPositionName",
        },
      ],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {},
  methods: {
    onSearchSubmit(params, selectedRows) {
      console.log("onSearchSubmit", params);
      this.$emit("handleOverlay", true);

      const _this = this;
      if (params.groupId) {
        subcommitteeStore
          .getSearchForAdd(params.groupId)
          .then(function(response) {
            // handle success
            console.log("then", response);
            _this.rows = response.data.data;
            _this.selectedRows = [];

            /// มาไล่เช็คว่า selectedRows มีตรงไหนตรงกับ rows บ้าง
            if (selectedRows && selectedRows.length > 0) {
              _this.rows.forEach((row) => {
                const isSelected = selectedRows.some(
                  (selectedRow) => selectedRow.committeeData.id === row.committeeData.id
                );
                console.log("isSelected", isSelected);
                if (isSelected) {
                  row.vgtSelected = true;
                  _this.selectedRows.push(row);
                }
              });
            }

            console.log("result", _this.rows);
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
            console.log("GET");
            _this.$emit("handleOverlay", false);
          });
      }
    },
    selectionChanged() {
      //console.log("selectionChanged", this.selectedRows);
      console.log("selectionChanged", this.$refs["my-table-user"].selectedRows);
      //console.log("ref", this.$refs);
      this.$emit("handle-select", this.$refs["my-table-user"].selectedRows);
    },
  },
};
</script>
